// src/components/AboutSection.jsx
import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Vision from './Vision';
import Mission from './Mission';
import StorySection from './StorySection';
import '../assets/css/Aboutus.css'
import Navbar from './Navbar';
import { Link } from 'react-router-dom';
import Footer from './Footer';
import Contactus from '../components/Contactus';
import { Helmet } from 'react-helmet';




const AboutSection = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
    });
  }, []);

  return (
    <>
    <Helmet>
        {/* <title>TechSol Technologies | About Us</title> */}
        <title>About Us | TechSol Technologies </title>
        <meta name="description" content="Learn more about TechSol Technologies and our services." />
      </Helmet>
      <div>
        <Navbar />
      </div>
      {/* Enhanced Hero Section */}
      <section className="contact-hero" data-aos="fade-up">
        <div className="hero-background">
          <div className="hero-glow"></div>
        </div>
        <div className="container">
          <div className="hero-content text-center">
            <h1 className="hero-title">
              About <span className="gradient-text">Us</span>
            </h1>
            <p className="hero-subtitle">
              Ready to start your next project? Let's discuss how we can bring your ideas to life.
            </p>
            <div className="breadcrumb">
              <Link to="/" className="breadcrumb-link">Home</Link>
              <span className="breadcrumb-separator"> / </span>
              <span className="breadcrumb-active">Contact</span>
            </div>
          </div>
        </div>
      </section>

      <div data-aos="fade-up">
        <StorySection />
      </div>
      
      <div data-aos="fade-up" data-aos-delay="100">
        <Vision />
      </div>
      
      <div data-aos="fade-up" data-aos-delay="200">
        <Mission />
      </div>
      
      <div>
        <Footer />
      </div>
    </>
  );
};

export default AboutSection;
